import { useBreakpointValue, useDisclosure } from "@biblioteksentralen/react";
import { eventIsFinished, isNonNil, ResolvedEventSummary } from "@libry-content/common";

export const useCampaignEvents = (allEvents: ResolvedEventSummary[] | null | undefined) => {
  const events = allEvents?.filter((event) => !!event && !eventIsFinished(event)).filter(isNonNil) || [];

  const initialNEvents = useBreakpointValue({ base: 2, sm: 4, md: 6 });
  const { open: showingAllEvents, onToggle: toggleAllEvents } = useDisclosure();
  const nEvents = showingAllEvents ? undefined : initialNEvents;
  const haveAdditionalEvents = !!initialNEvents && events.length > initialNEvents;

  return { events: events.slice(0, nEvents), showingAllEvents, toggleAllEvents, haveAdditionalEvents };
};
